export class ListSparkEnginesResponse {
    'sparkEngines';
    'pagination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sparkEngines",
            "baseName": "sparkEngines",
            "type": "Array<SparkEngine>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSparkEnginesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
